var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
var ReviewsList = /** @class */ (function (_super) {
    __extends(ReviewsList, _super);
    function ReviewsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Име', key: 'name', filter: false, sort: false },
            { name: 'Коментар', key: 'body', filter: false, sort: false },
            { name: 'Рейтинг', key: 'rating', filter: false, sort: false },
            { name: 'E-mail на потребителя', key: 'user_email', filter: false, sort: false },
        ];
        _this.editReview = function (rowItem) {
            _this.props.edit(_.get(rowItem, 'id', '-1'));
        };
        _this.onPage = function (event) {
            _this.props.getAllReviews(event.page + 1);
        };
        _this.deleteReview = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0442\u043E\u0437\u0438 \u043E\u0442\u0437\u0438\u0432?");
            if (ask) {
                _this.api.deleteReview(selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Отзивът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    ReviewsList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, lazy: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), onPage: this.onPage, editAction: this.editReview, deleteAction: this.deleteReview }));
    };
    return ReviewsList;
}(React.Component));
// @ts-ignore
export default withRouter(ReviewsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Reviews/ReviewsList/ReviewsList.tsx
// module id = 438
// module chunks = 0